import React from 'react';
import { Header } from './Header';
import { Hero } from './Hero';
import { AuthorityStatement } from './AuthorityStatement';
import { PositioningSection } from './PositioningSection';
import { ComparisonSection } from './ComparisonSection';
import { CapabilitiesGrid } from './CapabilitiesGrid';
import { SocialProof } from './SocialProof';
import { HardClaims } from './HardClaims';
import { FinalCTA } from './FinalCTA';
import { Footer } from './Footer';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-background" data-id="element-153">
      <Header data-id="element-154" />
      <main data-id="element-155">
        <Hero data-id="element-156" />
        <AuthorityStatement data-id="element-157" />
        <PositioningSection data-id="element-158" />
        <ComparisonSection data-id="element-159" />
        <CapabilitiesGrid data-id="element-160" />
        <SocialProof data-id="element-161" />
        <HardClaims data-id="element-162" />
        <FinalCTA id="pricing" data-id="element-163" />
      </main>
      <Footer data-id="element-164" />
    </div>;
}